var map = {
	"./challenge.png": 4,
	"./communicate.png": 17,
	"./environment.png": 18,
	"./exercise.png": 19,
	"./explore.png": 20,
	"./friendship.png": 21,
	"./gaming.png": 22,
	"./gardening.png": 23,
	"./grateful.png": 24,
	"./handwritten letter.png": 25,
	"./holiday.png": 26,
	"./meal.png": 27,
	"./meditate.png": 28,
	"./nature.png": 29,
	"./pets.png": 30,
	"./positivity.png": 31,
	"./productivity.png": 32,
	"./read.png": 33,
	"./relax.png": 34,
	"./stay-at-home.png": 35,
	"./team.png": 36,
	"./thanks.png": 37,
	"./tidy.png": 38,
	"./training-at-home.png": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;